/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  CreateDeviceCommandDtoTx,
  CreateDeviceDtoTx,
  CreateDeviceEventDtoTx,
  DeleteDeviceCommandDtoTx,
  DeleteDeviceDtoTx,
  DeleteDeviceEventDtoTx,
  DeleteDeviceOriginalDtoTx,
  DeviceControllerCreateReportParams,
  DeviceControllerCreateReportWtihOptionsParams,
  DeviceControllerGetCommandsParams,
  DeviceControllerGetDeviceParams,
  DeviceControllerGetDevicesParams,
  DeviceControllerGetEventsParams,
  DeviceControllerGetHistoryParams,
  DeviceControllerGetOriginalDataParams,
  GetDetailDeviceDtoRx,
  GetDetailDeviceOriginalDtoRx,
  GetDetailDeviceSensorDtoRx,
  GetDeviceCommandDetailDtoRx,
  GetDeviceCommandDtoRx,
  GetDeviceDtoRx,
  GetDeviceDtoStep1Rx,
  GetDeviceEventDetailDtoRx,
  GetDeviceEventDtoRx,
  GetDeviceHistoryDtoRx,
  GetDeviceModelPropertiesDtoRx,
  GetDeviceReportDtoRx,
  GetDeviceSettingDtoRx,
  GetModelListDtoRx,
  GetUpdateDeviceDtoRx,
  UpdateDeviceAlarmAndCalibrationDtoTx,
  UpdateDeviceCommandDtoTx,
  UpdateDeviceDtoTx,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class DeviceApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDeviceDataArray
   * @summary 디바이스 목록 조회에 필요한 데이터 반환_디바이스 모델, 사이트 배열
   * @request GET:/api/device/data
   * @secure
   */
  deviceControllerGetDeviceDataArray = (params: RequestParams = {}) =>
    this.request<GetDeviceDtoStep1Rx, any>({
      path: `/api/device/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDevices
   * @summary 디바이스 목록 조회
   * @request GET:/api/device
   * @secure
   */
  deviceControllerGetDevices = (query: DeviceControllerGetDevicesParams, params: RequestParams = {}) =>
    this.request<GetDeviceDtoRx, any>({
      path: `/api/device`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerCreateDevice
   * @summary 디바이스 등록
   * @request POST:/api/device
   * @secure
   */
  deviceControllerCreateDevice = (data: CreateDeviceDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerDeleteDevice
   * @summary 디바이스 삭제
   * @request DELETE:/api/device
   * @secure
   */
  deviceControllerDeleteDevice = (data: DeleteDeviceDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetModelList
   * @summary 디바이스 등록에 필요한 모델 배열 조회
   * @request GET:/api/device/model
   * @secure
   */
  deviceControllerGetModelList = (params: RequestParams = {}) =>
    this.request<GetModelListDtoRx[], any>({
      path: `/api/device/model`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerCreateDevice2
   * @summary 디바이스 등록
   * @request POST:/api/device/2
   * @secure
   */
  deviceControllerCreateDevice2 = (data: CreateDeviceDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/2`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerCreateReport
   * @summary 리포트 생성
   * @request POST:/api/device/report
   * @secure
   */
  deviceControllerCreateReport = (query: DeviceControllerCreateReportParams, params: RequestParams = {}) =>
    this.request<GetDeviceReportDtoRx[], any>({
      path: `/api/device/report`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerCreateReportWtihOptions
   * @summary 옵션을 바탕으로 리포트 생성
   * @request POST:/api/device/report/options
   * @secure
   */
  deviceControllerCreateReportWtihOptions = (
    query: DeviceControllerCreateReportWtihOptionsParams,
    params: RequestParams = {},
  ) =>
    this.request<GetDeviceReportDtoRx[], any>({
      path: `/api/device/report/options`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDeviceDetail
   * @summary 디바이스 상세 조회
   * @request GET:/api/device/{id}
   * @secure
   */
  deviceControllerGetDeviceDetail = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailDeviceDtoRx, any>({
      path: `/api/device/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerUpdateDevice
   * @summary 디바이스 수정
   * @request PUT:/api/device/{id}
   * @secure
   */
  deviceControllerUpdateDevice = (id: number, data: UpdateDeviceDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDevice
   * @summary 디바이스 상세 조회 - 센서 데이터
   * @request GET:/api/device/{id}/sensor-data
   * @secure
   */
  deviceControllerGetDevice = ({ id, ...query }: DeviceControllerGetDeviceParams, params: RequestParams = {}) =>
    this.request<GetDetailDeviceSensorDtoRx, any>({
      path: `/api/device/${id}/sensor-data`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerDeleteSensorData
   * @summary 센서 데이터 삭제
   * @request DELETE:/api/device/{id}/sensor-data
   * @secure
   */
  deviceControllerDeleteSensorData = (id: number, data: DeleteDeviceOriginalDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}/sensor-data`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetUpdateDeviceData
   * @summary 디바이스 수정을 위한 데이터 반환
   * @request GET:/api/device/{id}/update
   * @secure
   */
  deviceControllerGetUpdateDeviceData = (id: number, params: RequestParams = {}) =>
    this.request<GetUpdateDeviceDtoRx, any>({
      path: `/api/device/${id}/update`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetOriginalData
   * @summary 원본 데이터 조회
   * @request GET:/api/device/{id}/original-data
   * @secure
   */
  deviceControllerGetOriginalData = (
    { id, ...query }: DeviceControllerGetOriginalDataParams,
    params: RequestParams = {},
  ) =>
    this.request<GetDetailDeviceOriginalDtoRx, any>({
      path: `/api/device/${id}/original-data`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerDeleteOriginalData
   * @summary 원본 데이터 삭제
   * @request DELETE:/api/device/{id}/original-data
   * @secure
   */
  deviceControllerDeleteOriginalData = (id: number, data: DeleteDeviceOriginalDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}/original-data`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetHistory
   * @summary 설정 변경 이력 조회
   * @request GET:/api/device/{id}/history
   * @secure
   */
  deviceControllerGetHistory = ({ id, ...query }: DeviceControllerGetHistoryParams, params: RequestParams = {}) =>
    this.request<GetDeviceHistoryDtoRx, any>({
      path: `/api/device/${id}/history`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDeviceSetting
   * @summary 알림/교정값 상세 조회
   * @request GET:/api/device/{id}/setting
   * @secure
   */
  deviceControllerGetDeviceSetting = (id: number, params: RequestParams = {}) =>
    this.request<GetDeviceSettingDtoRx, any>({
      path: `/api/device/${id}/setting`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerUpdateSetting
   * @summary 알림/교정값 수정
   * @request PUT:/api/device/{id}/setting
   * @secure
   */
  deviceControllerUpdateSetting = (
    id: number,
    data: UpdateDeviceAlarmAndCalibrationDtoTx,
    params: RequestParams = {},
  ) =>
    this.request<Common, any>({
      path: `/api/device/${id}/setting`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetEvents
   * @summary 이벤트 설정 조회
   * @request GET:/api/device/{id}/events
   * @secure
   */
  deviceControllerGetEvents = ({ id, ...query }: DeviceControllerGetEventsParams, params: RequestParams = {}) =>
    this.request<GetDeviceEventDtoRx, any>({
      path: `/api/device/${id}/events`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDeviceModelProperties
   * @summary 이벤트 추가를 위한 데이터 반환(모델의 property)
   * @request GET:/api/device/{id}/modelProperties
   * @secure
   */
  deviceControllerGetDeviceModelProperties = (id: number, params: RequestParams = {}) =>
    this.request<GetDeviceModelPropertiesDtoRx, any>({
      path: `/api/device/${id}/modelProperties`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerCreateEvent
   * @summary 이벤트 추가
   * @request POST:/api/device/{id}/event
   * @secure
   */
  deviceControllerCreateEvent = (id: number, data: CreateDeviceEventDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}/event`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerDeleteEvent
   * @summary 이벤트 설정 삭제
   * @request DELETE:/api/device/{id}/event
   * @secure
   */
  deviceControllerDeleteEvent = (id: number, data: DeleteDeviceEventDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}/event`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDeviceEventDetail
   * @summary 이벤트 설정 상세 조회
   * @request GET:/api/device/{id}/event/{eventid}
   * @secure
   */
  deviceControllerGetDeviceEventDetail = (id: number, eventid: number, params: RequestParams = {}) =>
    this.request<GetDeviceEventDetailDtoRx, any>({
      path: `/api/device/${id}/event/${eventid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerUpdateEvent
   * @summary 이벤트 수정
   * @request PUT:/api/device/{id}/event/{eventid}
   * @secure
   */
  deviceControllerUpdateEvent = (
    id: number,
    eventid: number,
    data: CreateDeviceEventDtoTx,
    params: RequestParams = {},
  ) =>
    this.request<Common, any>({
      path: `/api/device/${id}/event/${eventid}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetCommands
   * @summary 디바이스 명령어 조회
   * @request GET:/api/device/{id}/commands
   * @secure
   */
  deviceControllerGetCommands = ({ id, ...query }: DeviceControllerGetCommandsParams, params: RequestParams = {}) =>
    this.request<GetDeviceCommandDtoRx, any>({
      path: `/api/device/${id}/commands`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerCreateCommand
   * @summary 디바이스 명령어 추가
   * @request POST:/api/device/{id}/command
   * @secure
   */
  deviceControllerCreateCommand = (id: number, data: CreateDeviceCommandDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}/command`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerDeleteCommand
   * @summary 디바이스 명령어 삭제
   * @request DELETE:/api/device/{id}/command
   * @secure
   */
  deviceControllerDeleteCommand = (id: number, data: DeleteDeviceCommandDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/device/${id}/command`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerGetDeviceCommandDetail
   * @summary 디바이스 명령어 상세 조회
   * @request GET:/api/device/{id}/command/{commandid}
   * @secure
   */
  deviceControllerGetDeviceCommandDetail = (id: number, commandid: number, params: RequestParams = {}) =>
    this.request<GetDeviceCommandDetailDtoRx, any>({
      path: `/api/device/${id}/command/${commandid}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Device API
   * @name DeviceControllerUpdateCommand
   * @summary 디바이스 명령어 수정
   * @request PUT:/api/device/{id}/command/{commandid}
   * @secure
   */
  deviceControllerUpdateCommand = (
    id: number,
    commandid: number,
    data: UpdateDeviceCommandDtoTx,
    params: RequestParams = {},
  ) =>
    this.request<Common, any>({
      path: `/api/device/${id}/command/${commandid}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
